import { useEffect, useState } from "react";
import styles from "./Search.module.css";
import Header from "../../components/Header/Header";
import SubHeader from "../../components/SubHeader/SubHeader";
import { MdClose, MdFilterList, MdKeyboardArrowRight } from "react-icons/md";
import { THEME } from "../../utils/THEME";
import CardProduto from "../../components/CardProduto/CardProduto";
import Footer from "../../components/footer/Footer";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import SelectDemo from "../../components/Select/Select";
import { useTranslation } from "react-i18next";
import FilterPanel from "./FilterPanel";
import { useProductSearch } from "./useProductSearch";

export default function Search() {
  const { t } = useTranslation("translation", { keyPrefix: "Search" });
  const { products, pages } = useProductSearch();
  const { page } = useParams();
  const [paramQuery] = useSearchParams();
  const filterSelected = paramQuery.get("filter");
  const navigate = useNavigate();

  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(window.innerWidth < 768);
  const [showFilters, setShowFilters] = useState(!isSmallScreen);

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth < 768);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filterDisplayMap: Record<string, string> = {
    maisVendidos: t("mostSold"),
    recentes: t("mostSearch"),
    promocoes: t("recommended"),
  };
  const selectedValue = filterSelected
    ? (filterDisplayMap[filterSelected] ?? t("relevant"))
    : t("relevant");

  function handleFilterChange(value: string) {
    const filterParamMap: Record<string, string> = {
      [t("mostSold")]: "maisVendidos",
      [t("mostSearch")]: "recentes",
      [t("recommended")]: "promocoes",
    };
    const newParams = new URLSearchParams(paramQuery.toString());
    const filterParam = filterParamMap[value];
    if (filterParam) newParams.set("filter", filterParam);
    else newParams.delete("filter");
    navigate(`/search/1?${newParams.toString()}`);
  }

  return (
    <>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
        hamburgerIcon={false}
      />
      <SubHeader isSmallScreen={isSmallScreen} />
      <div className={styles.containerBody}>
        <div className={styles.pageInfo}>
          <p>{t("initialPage")}</p>
          <MdKeyboardArrowRight size={22} color={THEME.COLORS.PRIMARY} />
          <p>{t("search")}</p>
        </div>

        <h1>
          {t("results")}
          <button className={styles.filterButton} onClick={() => setShowFilters(!showFilters)}>
            {showFilters ? <MdClose size={22} /> : <MdFilterList size={22} />}
          </button>
        </h1>

        <div className={styles.wrapperBody}>
          {showFilters && <FilterPanel />}

          <div className={styles.products}>
            <div className="containerSelect">
              <SelectDemo
                selectedValue={selectedValue}
                setSelectedValue={handleFilterChange}
                selectedValues={[t("relevant"), t("mostSearch"), t("recommended"), t("mostSold")]}
              />
            </div>
            <div className={styles.horizontalLine} />
            <div className={styles.wrapperProducts}>
              {products?.map((item, key) => (
                <CardProduto key={key} produto={item} />
              ))}
            </div>
            <div className={styles.pages}>
              {Array.from({ length: pages }, (_, i) => i + 1).map((item, key) => (
                <Link
                  key={key}
                  style={
                    item === Number(page)
                      ? { textDecorationLine: "none", fontSize: "1.1rem", width: "2rem", height: "2rem", backgroundColor: THEME.COLORS.PRIMARY, color: THEME.COLORS.WHITE, borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }
                      : { textDecorationLine: "none", fontSize: "1rem", width: "1.8rem", height: "1.8rem", backgroundColor: THEME.COLORS.WHITE, color: "black", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }
                  }
                  to={`/search/${item}?${paramQuery.toString()}`}
                >
                  {item}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      {!isSmallScreen && <Footer />}
    </>
  );
}
